module.exports = __webpack_public_path__ + "static/media/pappadi.d8fae41e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/pappadi.gif
// module id = 328
// module chunks = 0